export const regexBarcode = (input: string): string => {
  let sku = input;

  // Check if the input length is greater than 8 and process accordingly
  if (sku.length > 8) {
    // Extract the part before the first '&' character
    sku = sku.split("&")[0];

    // If the extracted part starts with 'n=', remove the 'n=' part
    if (sku.startsWith("n=")) {
      sku = sku.substring(2);
    }

    if (sku.includes("HYDROGEL")) {
      const list_sku = sku.split("-");
      sku = list_sku[0] + "-" + list_sku[1] + "-" + list_sku[2];
    }

    if (sku.includes("HYDROPLUS")) {
      const list_sku = sku.split("-");
      sku = list_sku[0] + "-" + list_sku[1];
    }
  }

  return sku;
};
